/** R12-02 — Conexão do Microsoft Entra ID com o aplicativo do próprio cliente (Central de integrações). */
const en = {
  'integ.state.pending': 'Pending',
  'entra.pending': 'Pending: {reason}',
  'entra.app.title': 'Application in Microsoft Entra',
  'entra.app.lead':
    'Microsoft Entra ID is read by an application registered in your directory, with Microsoft Graph application permissions — not by a user. A service account does not help here: what counts is the application and the permissions granted to it.',
  'entra.app.own': 'Your application',
  'entra.app.installation': "The installation's application (default)",
  'entra.app.none': 'No application yet: fill in the application (client) ID and its secret or certificate in Edit connection.',
  'entra.app.secretMissing': 'The application has no secret or certificate stored: paste one in Edit connection.',
  'entra.app.which': 'Application used',
  'entra.app.clientId': 'Application (client) ID',
  'entra.app.tenantId': 'Directory (tenant) ID',
  'entra.app.credential': 'Credential',
  'entra.app.cred.secret': 'Client secret (in the vault)',
  'entra.app.cred.certificate': 'Certificate (in the vault)',
  'entra.app.cred.missing': 'Not stored',
  'entra.app.validUntil': 'Valid until',
  'entra.app.validUnknown': 'Not informed (fill in "Secret expires on")',
  'entra.app.expiring': 'The secret or certificate expires in {n} days ({date}). Create a new one in Microsoft Entra and paste it in Edit connection.',
  'entra.app.expired': 'The secret or certificate expired on {date}. Create a new one in Microsoft Entra and paste it in Edit connection.',
  'entra.app.redirect': 'Redirect URI to register in the application (Web platform)',
  'entra.app.redirectHint': 'Needed only for Open administrator consent from Hive. Granting the consent on the API permissions page of the application also works.',
  'entra.app.permissionsPage': 'Permissions of the application in Microsoft Entra',
  'entra.app.consent': 'Open administrator consent',
  'entra.app.change': 'Change application',
  'entra.app.useOwn': 'Use your own application',
  'entra.app.help': 'The step by step (register the application, grant the permissions and the consent, paste and test) is in the help: Step by step: connect Microsoft Entra ID with your application.',
  'entra.perm.title': 'Permissions by use',
  'entra.perm.tested': 'Tested with {app} · directory {tenant}',
  'entra.perm.own': 'your application {id}',
  'entra.perm.installation': "the installation's application",
  'entra.perm.ok': 'complete',
  'entra.perm.missing': 'missing {perms}',
  'entra.perm.atSignIn': 'asked at sign-in: {perms}',
  'entra.perm.granted': 'Granted to the application: {perms}',
  'entra.perm.noneGranted': 'No application permission was granted yet: grant the administrator consent.',
  'entra.perm.fixLink': 'Add the permissions in Microsoft Entra',
  'entra.edit.note':
    'Changing the application keeps the uses and the history. Secrets never come back to the screen: leave a secret field empty to keep the current one. After saving, Hive tests the connection.',
  'entra.back.connected': 'The administrator consent was given. Testing the permissions now…',
  'entra.back.error': 'The administrator consent was not given: {reason}',
};

const ptBR: Record<keyof typeof en, string> = {
  'integ.state.pending': 'Pendente',
  'entra.pending': 'Pendente: {reason}',
  'entra.app.title': 'Aplicativo no Microsoft Entra',
  'entra.app.lead':
    'O Microsoft Entra ID é lido por um aplicativo registrado no seu diretório, com permissões de aplicativo do Microsoft Graph — não por um usuário. Uma conta de serviço não resolve: o que vale é o aplicativo e as permissões concedidas a ele.',
  'entra.app.own': 'Seu aplicativo',
  'entra.app.installation': 'Aplicativo da instalação (padrão)',
  'entra.app.none': 'Ainda sem aplicativo: preencha o ID do aplicativo (cliente) e o segredo ou o certificado em Editar conexão.',
  'entra.app.secretMissing': 'O aplicativo está sem segredo ou certificado guardado: cole um em Editar conexão.',
  'entra.app.which': 'Aplicativo usado',
  'entra.app.clientId': 'ID do aplicativo (cliente)',
  'entra.app.tenantId': 'ID do diretório (locatário)',
  'entra.app.credential': 'Credencial',
  'entra.app.cred.secret': 'Segredo do cliente (no cofre)',
  'entra.app.cred.certificate': 'Certificado (no cofre)',
  'entra.app.cred.missing': 'Não guardado',
  'entra.app.validUntil': 'Válido até',
  'entra.app.validUnknown': 'Não informado (preencha "Segredo vence em")',
  'entra.app.expiring': 'O segredo ou certificado vence em {n} dias ({date}). Crie outro no Microsoft Entra e cole em Editar conexão.',
  'entra.app.expired': 'O segredo ou certificado venceu em {date}. Crie outro no Microsoft Entra e cole em Editar conexão.',
  'entra.app.redirect': 'Endereço de retorno a cadastrar no aplicativo (plataforma Web)',
  'entra.app.redirectHint': 'Só é preciso para Abrir consentimento do administrador pelo Hive. Conceder o consentimento na página Permissões de API do aplicativo também vale.',
  'entra.app.permissionsPage': 'Permissões do aplicativo no Microsoft Entra',
  'entra.app.consent': 'Abrir consentimento do administrador',
  'entra.app.change': 'Trocar aplicativo',
  'entra.app.useOwn': 'Usar o seu aplicativo',
  'entra.app.help': 'O passo a passo (registrar o aplicativo, dar as permissões e o consentimento, colar e testar) está na ajuda: Passo a passo: conectar o Microsoft Entra ID com o seu aplicativo.',
  'entra.perm.title': 'Permissões por uso',
  'entra.perm.tested': 'Testado com {app} · diretório {tenant}',
  'entra.perm.own': 'o seu aplicativo {id}',
  'entra.perm.installation': 'o aplicativo da instalação',
  'entra.perm.ok': 'completas',
  'entra.perm.missing': 'falta {perms}',
  'entra.perm.atSignIn': 'pedidas no login: {perms}',
  'entra.perm.granted': 'Concedidas ao aplicativo: {perms}',
  'entra.perm.noneGranted': 'Nenhuma permissão de aplicativo concedida ainda: conceda o consentimento do administrador.',
  'entra.perm.fixLink': 'Acrescentar as permissões no Microsoft Entra',
  'entra.edit.note':
    'Trocar o aplicativo mantém os usos e o histórico. Segredos nunca voltam à tela: deixe o campo de segredo vazio para manter o atual. Ao salvar, o Hive testa a conexão.',
  'entra.back.connected': 'O consentimento do administrador foi dado. Testando as permissões agora…',
  'entra.back.error': 'O consentimento do administrador não foi dado: {reason}',
};

const es: Record<keyof typeof en, string> = {
  'integ.state.pending': 'Pendiente',
  'entra.pending': 'Pendiente: {reason}',
  'entra.app.title': 'Aplicación en Microsoft Entra',
  'entra.app.lead':
    'Microsoft Entra ID se lee mediante una aplicación registrada en su directorio, con permisos de aplicación de Microsoft Graph — no mediante un usuario. Una cuenta de servicio no sirve aquí: lo que cuenta es la aplicación y los permisos concedidos a ella.',
  'entra.app.own': 'Su aplicación',
  'entra.app.installation': 'Aplicación de la instalación (predeterminada)',
  'entra.app.none': 'Aún sin aplicación: complete el ID de la aplicación (cliente) y su secreto o certificado en Editar conexión.',
  'entra.app.secretMissing': 'La aplicación no tiene secreto ni certificado guardado: pegue uno en Editar conexión.',
  'entra.app.which': 'Aplicación usada',
  'entra.app.clientId': 'ID de la aplicación (cliente)',
  'entra.app.tenantId': 'ID del directorio (inquilino)',
  'entra.app.credential': 'Credencial',
  'entra.app.cred.secret': 'Secreto de cliente (en la bóveda)',
  'entra.app.cred.certificate': 'Certificado (en la bóveda)',
  'entra.app.cred.missing': 'No guardado',
  'entra.app.validUntil': 'Válido hasta',
  'entra.app.validUnknown': 'No informado (complete "El secreto vence el")',
  'entra.app.expiring': 'El secreto o certificado vence en {n} días ({date}). Cree otro en Microsoft Entra y péguelo en Editar conexión.',
  'entra.app.expired': 'El secreto o certificado venció el {date}. Cree otro en Microsoft Entra y péguelo en Editar conexión.',
  'entra.app.redirect': 'URI de redirección a registrar en la aplicación (plataforma Web)',
  'entra.app.redirectHint': 'Solo hace falta para Abrir consentimiento del administrador desde Hive. Conceder el consentimiento en la página Permisos de API de la aplicación también sirve.',
  'entra.app.permissionsPage': 'Permisos de la aplicación en Microsoft Entra',
  'entra.app.consent': 'Abrir consentimiento del administrador',
  'entra.app.change': 'Cambiar aplicación',
  'entra.app.useOwn': 'Usar su propia aplicación',
  'entra.app.help': 'El paso a paso (registrar la aplicación, conceder los permisos y el consentimiento, pegar y probar) está en la ayuda: Paso a paso: conectar Microsoft Entra ID con su aplicación.',
  'entra.perm.title': 'Permisos por uso',
  'entra.perm.tested': 'Probado con {app} · directorio {tenant}',
  'entra.perm.own': 'su aplicación {id}',
  'entra.perm.installation': 'la aplicación de la instalación',
  'entra.perm.ok': 'completos',
  'entra.perm.missing': 'falta {perms}',
  'entra.perm.atSignIn': 'pedidos al iniciar sesión: {perms}',
  'entra.perm.granted': 'Concedidos a la aplicación: {perms}',
  'entra.perm.noneGranted': 'Aún no se concedió ningún permiso de aplicación: conceda el consentimiento del administrador.',
  'entra.perm.fixLink': 'Agregar los permisos en Microsoft Entra',
  'entra.edit.note':
    'Cambiar la aplicación conserva los usos y el historial. Los secretos nunca vuelven a la pantalla: deje vacío el campo de secreto para conservar el actual. Al guardar, Hive prueba la conexión.',
  'entra.back.connected': 'Se dio el consentimiento del administrador. Probando los permisos ahora…',
  'entra.back.error': 'No se dio el consentimiento del administrador: {reason}',
};

export const entraAppMessages = { en, 'pt-BR': ptBR, es } as const;
